<script setup>
import {
  onMounted,
  reactive,
  ref,
} from 'vue';

import { DEFAULT_SORT, POST_PER_PAGE } from '../composable/useVideos';

import useVideos from '../composable/useVideos';

import PageVideos from './PageVideos.vue';

  const props = defineProps({
    currentCategory: {
      type: Number,
      required: true
    },

    categories: {
      type: Array,
      default: () => ([]),
    },
  });

  const {
    videos,
    loading,
    showMore,
    doFetch
  } = useVideos();

  const selectedCategories = ref([]);

  const fetchData = reactive({
    'video-category': props.currentCategory,
    'video-tag': selectedCategories.value,
    page: 1,
    per_page: POST_PER_PAGE,
    orderby: DEFAULT_SORT.orderBy,
    order: DEFAULT_SORT.order,
  });

  async function loadMore () {
    fetchData.per_page += POST_PER_PAGE;

    await doFetch(fetchData);
  }

  async function selectedCategory (values) {
    selectedCategories.value = values;

    fetchData['video-tag'] = (values || []).map((value) => value.id);

    await doFetch(fetchData);
  }

  async function changeSort (sort) {
    fetchData.orderby = sort.orderBy
    fetchData.order = sort.order

    await doFetch(fetchData);
  }

  onMounted(async () => {
    await doFetch(fetchData);
  });
</script>

<template>
  <PageVideos
    :videos="videos"
    :loading="loading"
    :show-more="showMore"
    :categories="categories"
    :selectedCategories="selectedCategories"
    type-filter-name="Tags"
    @handleChangeSort="changeSort"
    @handleLoadMore="loadMore"
    @handleSelectedCategory="selectedCategory"
  >
    <template #heading>
      <slot name="heading" />
    </template>

    <template #category-name>
      <slot name="name" />
    </template>

    <template #categories>
      <h4>Categories</h4>

      <slot name="categories" />
    </template>
  </PageVideos>
</template>

<style scoped>

</style>
